export const publicSupportAccessEnded = "danaro:public-support-access-ended"
